import { createContext } from 'react';

const drawingContext = createContext();

export default drawingContext;
